import { prefix } from '../../utils/prefix';

const Url = {
  getInfo: `${prefix}/info/declaration/get`,
  saveDraft: `${prefix}/draft/declaration/save`,
  save: `${prefix}/info/declaration/save`,
  getRelation: `${prefix}/dataset/familyRelation`, // 获取关系
};

export default Url;
